import { useMemo } from 'react';

import { WorkflowStepFormFieldBlock } from '~/core/shared/types';
import { getDefaultValuesForFormFields } from '../logic/getDefaultValuesForFormFields';

export const useEmptyValuesForFormFields = (
  formFieldBlocks: WorkflowStepFormFieldBlock[],
) => {
  const emptyValues = useMemo(
    () => getDefaultValuesForFormFields(formFieldBlocks),
    [formFieldBlocks],
  );

  return emptyValues;
};
